import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfig } from '../app.config';
import { PreliminaryScreeningLocationDetailView, PreliminaryScreeningResultDetailView } from '../contracts';

@Injectable()
export class PreliminaryScreeningService {
    constructor(private readonly http: HttpClient) { }

    public getScreeningResultDetails(id: string): Observable<PreliminaryScreeningResultDetailView> {
        const url = AppConfig.apiUrls.preliminaryScreenings.getResultDetails(id);
        return this.http.get<PreliminaryScreeningResultDetailView>(url);
    }

    public getLocationDetails(id: string): Observable<PreliminaryScreeningLocationDetailView> {
        const url = AppConfig.apiUrls.preliminaryScreenings.getLocationDetails(id);
        return this.http.get<PreliminaryScreeningLocationDetailView>(url);
    }
}
